import { render, staticRenderFns } from "./CompanyInfoSubscriptions.vue?vue&type=template&id=7b7f1ced&"
import script from "./CompanyInfoSubscriptions.vue?vue&type=script&lang=ts&"
export * from "./CompanyInfoSubscriptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b7f1ced')) {
      api.createRecord('7b7f1ced', component.options)
    } else {
      api.reload('7b7f1ced', component.options)
    }
    module.hot.accept("./CompanyInfoSubscriptions.vue?vue&type=template&id=7b7f1ced&", function () {
      api.rerender('7b7f1ced', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyInfoSubscriptions.vue"
export default component.exports